import { render, staticRenderFns } from "./settingPanel.vue?vue&type=template&id=48a4e3a4&scoped=true&"
import script from "./settingPanel.vue?vue&type=script&lang=js&"
export * from "./settingPanel.vue?vue&type=script&lang=js&"
import style0 from "./settingPanel.vue?vue&type=style&index=0&id=48a4e3a4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a4e3a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ljz/work-project/bi-base/biDashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48a4e3a4')) {
      api.createRecord('48a4e3a4', component.options)
    } else {
      api.reload('48a4e3a4', component.options)
    }
    module.hot.accept("./settingPanel.vue?vue&type=template&id=48a4e3a4&scoped=true&", function () {
      api.rerender('48a4e3a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settingPanel.vue"
export default component.exports